<script lang="ts">
	import type {
		CourseOfferingTypeEnum,
		SelectCourseOfferingDate,
		SelectLocation,
		SelectLocationGroup
	} from '$db/tables';

	interface Props {
		type: CourseOfferingTypeEnum;
		dates: (SelectCourseOfferingDate & {
			loc?: (SelectLocation & { locGroup?: SelectLocationGroup | null }) | null;
		})[];
	}

	let { type, dates }: Props = $props();

	const locationGroups = $derived.by(() =>
		Array.from(
			new Set(dates.map((courseOfferingDate) => courseOfferingDate.loc?.locGroup?.name))
		).join(' & ')
	);

	let typeDict = $derived({
		online: 'Live-Streaming',
		inPerson: locationGroups,
		hybrid: 'Hybrid',
		parallel: 'Parallel'
	});
</script>

{typeDict[type]}
